export default "__VITE_PUBLIC_ASSET__b46bddbf__"